export default function keywordFormat(keyword = []) {
    return keyword.join(', ');
}